import { Trophy } from "lucide-react";
import { type ExecMonthlyRow, formatMetric, METRIC_CONFIG, type RecordMetricKey } from "./types";

interface RecordBannerProps {
  recordKeys: RecordMetricKey[];
  currentRow: ExecMonthlyRow;
}

export function RecordBanner({ recordKeys, currentRow }: RecordBannerProps) {
  const [first] = recordKeys;
  const subtitle =
    recordKeys.length === 1 && first
      ? `${METRIC_CONFIG[first].label} just hit an all-time monthly high.`
      : `${recordKeys.length} metrics just hit all-time monthly highs.`;

  return (
    <div className="rounded-xl border border-brand-gold/40 bg-gradient-to-r from-brand-gold/10 via-brand-gold/5 to-transparent p-5 shadow-sm">
      <div className="flex items-start gap-4">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-gold/20 text-brand-gold">
          <Trophy className="h-6 w-6" />
        </div>
        <div className="flex-1">
          <h2 className="font-serif text-xl text-foreground">
            {recordKeys.length === 1 ? "New Company Record" : "New Company Records"} this month
          </h2>
          <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>
          <div className="mt-3 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {recordKeys.map((key) => {
              const config = METRIC_CONFIG[key];
              return (
                <div
                  key={key}
                  className="rounded-md border border-brand-gold/30 bg-background/60 p-3"
                >
                  <div className="text-[10px] tracking-widest uppercase text-muted-foreground">
                    {config.label}
                  </div>
                  <div className="mt-1 font-serif text-2xl text-foreground">
                    {formatMetric(currentRow[key], config.format)}
                  </div>
                  <div className="mt-1 text-xs text-muted-foreground">
                    New all-time monthly high
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
